
import Colaboradores from '@/components/Colaboradores.vue';
export default {
  name: 'ExploreContainer',
  components: { Colaboradores },
  props: {
    name: String
  }
}
